import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import PlanTrip from "../components/PlanTrip";
import AboutMain from "../images/about/about-main.jpg";
import Box1 from "../images/about/icon1.png";
import Box2 from "../images/about/icon2.png";
import Box3 from "../images/about/icon3.png";
import SEO from "../utils/seo";

function About() {
  return (
    <>
      <section className="about-page">
        <SEO
          title="MyDearCab - Top Cab Services in Pune"
          description="Book Pune to Mumbai cab at lowest fare. Clean cars, safe drivers, airport pickup & drop, 24/7 service. Sedan, SUV, Innova available. WhatsApp Booking: 8007722929."
          keywords="taxi service in pune,pune cab booking,pune airport cab service,pune airport pickup and drop,local taxi pune,online cab booking pune, pune to shirdi cab,pune to nashik cab,pune to aurangabad cab,pune to kolhapur cab,pune to goa cab,pune to mahabaleshwar cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai drop taxi,pune to mumbai car rental, pune to mumbai taxi lowest fare,pune to mumbai cab price,pune to mumbai cheap cab,pune to mumbai budget taxi,24 hours pune to mumbai cab,safe pune to mumbai cab for family,pune to mumbai airport drop cab,pune to mumbai sedan cab,pune to mumbai suv cab, pune airport to mumbai cab,hinjewadi to mumbai cab,swargate to mumbai cab,wakad to mumbai cab, pune to mumbai cab one way at affordable fare,pune to mumbai taxi service with driver,book pune to mumbai cab on whatsapp, pune to mumbai cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai one way taxi,pune to mumbai cab fare,pune to mumbai airport drop taxi,pune to mumbai online cab booking, Pune to Mumbai Cab | One Way Taxi | Lowest Fare | 24×7 Service, Near me cab service, Near me taxi service, Near me car rental services"
          canonicalUrl="https://www.mydearcab.com/about"
        />
        <HeroPages name="About" />
        <div className="container">
          <div className="about-main">
            <img
              className="about-main__img"
              src={AboutMain}
              alt="car-renting"
            />
            <div className="about-main__text">
              <h3>About MyDearCab</h3>
              <h2>Your journey begins with MyDearCab</h2>
              <p>
                MyDearCab is a leading cab service provider committed to
                offering safe, reliable, and comfortable transportation
                solutions. With our experienced drivers and well-maintained
                fleet, we ensure you reach your destination safely and on time.
                Our customer-centric approach and affordable pricing make us the
                preferred choice for travelers.
              </p>
              <div className="about-main__text__icons">
                <div className="about-main__text__icons__box">
                  <img src={Box1} alt="car-icon" />
                  <span>
                    <h4>8+</h4>
                    <p>Years of Service</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box2} alt="car-icon" />
                  <span>
                    <h4>7688+</h4>
                    <p>Happy Customers</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box3} alt="car-icon" className="last-fk" />
                  <span>
                    <h4>24/7</h4>
                    <p>Customer Support</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <PlanTrip />
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>Book a cab by getting in touch with MyDearCab</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3>+9170200 65876</h3>
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
